import React from 'react';

/**
 * Botón para alternar entre modo claro/oscuro. Recibe el estado y el
 * toggle desde el hook useTheme (montado una sola vez en AgendaPage).
 */
const ThemeToggle = ({ esOscuro, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    title={esOscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
    aria-label={esOscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
    style={{
      alignItems: 'center', background: 'var(--surface-alt)', border: '1px solid var(--border-secondary)',
      borderRadius: '50%', color: 'var(--text-secondary)', cursor: 'pointer', display: 'flex',
      flexShrink: 0, fontSize: '15px', height: '34px', justifyContent: 'center', width: '34px',
      transition: 'background-color .2s, color .2s',
    }}
  >
    {esOscuro ? '☀️' : '🌙'}
  </button>
);

export default ThemeToggle;
